import React, { useState, useEffect } from "react";
import { Button, Container, Row, Form, Alert } from 'react-bootstrap'
import { useHistory } from 'react-router'
import firebase from 'firebase/compat/app';
import { getAuth } from "firebase/auth";
import "firebase/database"
import './AddProduct.css'

function AddProduct() {

    const history = useHistory()

    const [productName, setProductName] = useState("")
    const [barcode, setBarcode] = useState("")
    const [code, setCode] = useState("")
    const [alert, setAlert] = useState("")


    function newProduct(e) {

        e.preventDefault()

        // ovo ispod komentara dodaje podatke iz forme na firebase

        const auth = getAuth();
        const user = auth.currentUser;
        const uid = user.uid;

        const newProductRef = firebase
            .database()
            .ref(uid + "/newProduct")


        const product = {
            productName,
            barcode,
            code
        }

        setProductName("")
        setBarcode("")
        setCode("")
        setAlert("")

        if (newProductRef.push(product)) {
            return setAlert("New product successfully added.")
        }

    }

    function handleChange1(e) {
        setProductName(e.target.value)
    }

    function handleChange2(e) {
        setBarcode(e.target.value)
    }

    function handleChange3(e) {
        setCode(e.target.value)
    }


    function routeChangeBack() {
        let path = `products`
        history.push(path)
    }

    useEffect(() => {
        setTimeout(() => {
            setAlert(false);
        }, 2000);
    }, [alert]);

    return (
        <div>
            <Container id="addprod">
                <Row>
                    <h4>Fill in the gaps to add a new product</h4>
                    {alert && <Alert variant="success">{alert}</Alert>}
                    <Form onSubmit={newProduct}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Product name</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange1} value={productName} as="textarea" placeholder="Enter product name" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter product name"} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Product barcode</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange2} value={barcode} as="textarea" placeholder="Enter barcode" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter barcode"} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Custom code</Form.Label>
                            <Form.Control className="input-color" onChange={handleChange3} value={code} as="textarea" placeholder="Enter your custom code" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter your custom code"} />
                        </Form.Group>
                        <Button onClick={routeChangeBack} variant="secondary" type="button">Back</Button>
                        <Button className="float-end" variant="dark" type="submit">Add product</Button>
                    </Form>
                </Row>
            </Container>
        </div>
    )
}

export default AddProduct